/** Shared helpers for the coaching chat UIs (inbox, messenger, dock, my-coaches). */

type PersonLike = { first_name?: string | null; last_name?: string | null; name?: string | null } | null | undefined;

/** Two-letter initials from a display name or a person object. */
export const initials = (person: PersonLike | string): string => {
  if (!person) {
    return '?';
  }
  const parts = typeof person === 'string'
    ? person.split(' ')
    : person.name
      ? person.name.split(' ')
      : [person.first_name || '', person.last_name || ''];
  return parts.filter(Boolean).slice(0, 2).map(p => p[0]?.toUpperCase()).join('') || '?';
};

export const isSameDay = (a?: string | null, b?: string | null): boolean =>
  !!a && !!b && new Date(a).toDateString() === new Date(b).toDateString();

/** Time today, otherwise a short date. */
export const listTime = (value?: string | null): string => {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  return isSameDay(value, new Date().toISOString())
    ? date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
    : date.toLocaleDateString([], { month: 'short', day: 'numeric' });
};

/** Admins (and legacy trainers) are coaches: they get the inbox + unread dock, not the user messenger. */
export const isStaff = (roles: readonly unknown[]): boolean => {
  const upper = roles.map(r => String(r).toUpperCase());
  return upper.includes('ADMIN') || upper.includes('TRAINER');
};

/** True on phones/tablets, where Enter should insert a newline instead of sending. */
export const isTouchDevice = (): boolean => {
  try {
    return window.matchMedia('(pointer: coarse)').matches;
  } catch {
    return false;
  }
};
